<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('adicionar-licenca') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="onFecharModal">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="licenca.idlicencaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!licenca.idlicencaerp"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="licenca.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!licenca.descricao"
                                uppercase
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(2)"
                                ref="bloqueiaSelect"
                                :options="bloqueiaSelect"
                                v-model="bloqueiaSelected"
                                class="no-clear"
                                :required="true"
                                title="bloqueia-licenca"
                                :invalid="!bloqueiaSelected"
                                tooltipLabel="info-bloqueia-venda"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(3)"
                                ref="statusSelect"
                                :options="statusSelect"
                                v-model="statusSelected"
                                class="no-clear"
                                :required="true"
                                title="situacao"
                                :invalid="!statusSelected"
                                :disabled="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LicencaService from '@/services/LicencaService';
import LicencaValidation from '@/services/validations/LicencaValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            service: new LicencaService(this.$http, this.$router),
            validation: new LicencaValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            licenca: {
                id: null,
                descricao: null,
                status: null,
                bloqueiavenda: null,
            },
            isUpdate: false,
            statusSelected: { id: 1, label: this.$t('ativo') },
            bloqueiaSelected: { id: 1, label: this.$t('sim') },
            statusSelect: [
                { id: 0, label: this.$t('inativo') },
                { id: 1, label: this.$t('ativo') },
            ],
            bloqueiaSelect: [
                { id: 0, label: this.$t('nao') },
                { id: 1, label: this.$t('sim') },
            ],
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'licencas');

        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'licenca' },
            });
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        save() {
            let isError = false;
            this.licenca = this.mapTosave(this.licenca);
            if (this.validation.validate(this.licenca, this.$refs)) {
                this.licenca.bloqueiavenda = this.bloqueiaSelected.id;
                this.licenca.status = this.statusSelected.id;
                this.isSaving = true;
                this.service
                    .save(this.licenca)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-licenca-salvo';
                            if (this.licenca.id) {
                                msg = 'msg-licenca-editado';
                            }
                            this.licenca = body.content;
                            this.msgs.push(new Message('success', msg, true));
                        } else {
                            isError = true;
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(message, { n: this.licenca.idlicencaerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                        isError = true;
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        if (!isError) {
                            this.onFecharModal();
                        }
                    });
            }
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
